import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import image1 from '../assets/images/image1.jpg';
import image2 from '../assets/images/image2.jpg';
import image3 from '../assets/images/image3.jpg';
import image4 from '../assets/images/image4.jpg';
import image5 from '../assets/images/image5.jpg';
import image7 from '../assets/images/image7.jpg';
import meImage from '../assets/images/me.jpg';
import newLogo from '../assets/images/newlogo.png';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const autoRotateRef = useRef(null);
  const [hoursPerWeek, setHoursPerWeek] = useState(5);
  const [hourlyRate, setHourlyRate] = useState(20);

  const testimonials = [
    {
      emoji: '🎓',
      quote: "Speed and Efficiency: One of the most impressive features of the AI auto-marker is its speed. Within just a few minutes, the AI generated a comprehensive assessment. This immediate feedback was a game-changer, particularly in an online learning environment where timely evaluations are crucial.",
      name: "Stepan",
      role: "Student",
      featured: true
    },
    {
      emoji: '👨‍🏫',
      quote: "You worked very hard on this project, and I'm sure it's going to help a lot of students. I see this being a very successful project, and for that, all I can say is well done.",
      name: "Anthony",
      role: "Student"
    },
    {
      emoji: '👨‍🎓',
      quote: "Amazing website!",
      name: "Aditya",
      role: "Student"
    },
    {
      emoji: '🧑‍🎓',
      quote: "AI AutoMarker is very good.",
      name: "Leo",
      role: "Student"
    }
  ];

  const statistics = [
    {
      icon: '⭐',
      value: 95,
      description: "of users rated their experience as excellent!"
    },
    {
      icon: '👍',
      value: 90,
      description: "of students would recommend AI AutoMarker to their peers."
    },
    {
      icon: '📊',
      value: 100,
      description: "Users consistently rate our feedback as detailed and helpful."
    }
  ];

  // Auto-rotate testimonials
  useEffect(() => {
    autoRotateRef.current = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    
    return () => {
      if (autoRotateRef.current) {
        clearInterval(autoRotateRef.current);
      }
    };
  }, [testimonials.length]);

  // Reset auto-rotation when manually changing testimonials
  const resetAutoRotate = () => {
    if (autoRotateRef.current) {
      clearInterval(autoRotateRef.current);
      autoRotateRef.current = setInterval(() => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    resetAutoRotate();
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    resetAutoRotate();
  };


  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <div className="landing-container">
      {/* Navbar */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src={newLogo} alt="AI AutoMarker Logo" className="nav-logo-image" />
            <span>AI AutoMarker</span>
          </div>
          
          {/* Mobile menu button */}
          <div className="mobile-menu-button" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          
          {/* Desktop navigation */}
          <div className={`nav-links ${showMobileMenu ? 'mobile-active' : ''}`}>
            <a href="#home" className="nav-link" onClick={() => setShowMobileMenu(false)}>Home</a>
            <a href="#features" className="nav-link" onClick={() => setShowMobileMenu(false)}>Features</a>
            <a href="#about-section" className="nav-link" onClick={() => setShowMobileMenu(false)}>About</a>
            <a href="#contact-section" className="nav-link" onClick={() => setShowMobileMenu(false)}>Contact</a>
            <button onClick={() => window.location.href = '/login'} className="login-button">
              <span className="button-text">Login</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Teacher banner */}
      <div className="teacher-banner">
        <span>👩‍🏫</span> Created by teachers, for teachers
      </div>

      {/* Hero Section */}
      <section className="hero" id="home" style={{ backgroundImage: `url(${image7})` }}>
        <div className="hero-overlay">
          <h1>Smarter Marking for Modern Classrooms</h1>
          <p>AI AutoMarker grades written responses with accuracy and care — complete with detailed feedback, accessibility tools, and exportable results.</p>
          <button className="demo-button" onClick={() => {
            document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
          }}>
            <span className="button-text">Book a Demo</span>
            <span className="button-icon">→</span>
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section className="features" id="features">
        <h2 className="title-green">Key Features</h2>
        <div className="features-grid">
          <div className="feature">
            <div className="feature-icon">✅</div>
            <h3>AI-Assisted Marking</h3>
            <p>Provide a model answer and let the AI compare student responses for accuracy and relevance.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🧾</div>
            <h3>Mark Scheme Uploads</h3>
            <p>Teachers can upload custom mark schemes the AI can reference.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📈</div>
            <h3>Result Tracking</h3>
            <p>View, export, and analyze student results across classes.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">👩‍🏫</div>
            <h3>Teacher-Controlled</h3>
            <p>AI assists — but you stay in control. Accept or override marks at any time.</p>
          </div>
        </div>
      </section>

      {/* Story Section - White */}
      <section id="about-section" className="story-section">
        <div className="story-container">
          <div className="story-content">
            <span className="subtitle">My Story</span>
            <h2 className="story-title">Built from the Classroom Up</h2>
            <p className="story-text">
              As a Computing teacher, I experienced firsthand the challenges of consistent marking 
              and timely feedback. AI AutoMarker was born from countless hours spent grading and 
              the belief that there had to be a better way.
            </p>
            <div className="author-badge">
            <div className="author-avatar" style={{ backgroundImage: `url(${meImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              <div className="author-details">
                <span className="author-name">Mr. Ryan Higgins</span>
                <span className="author-role">Computing Teacher & Founder</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demo Section - Light Blue */}
      <section className="demo-section">
        <div className="demo-container">
          <h2 className="demo-title">See It In Action</h2>
          <div className="video-container">
            {/* Video placeholder */}
            <div className="video-placeholder">
              Demo Video Coming Soon
            </div>
          </div>
        </div>
      </section>

      {/* Preview Section with Images */}
      <section className="preview">
        <div className="section-container">
          <h2 className="title-green">Platform Preview</h2>
          <div className="preview-grid">
            <div className="preview-card">
              <img src={image1} alt="AI AutoMarker Interface" className="preview-image" />
              <p>Intuitive Teacher Dashboard</p>
            </div>
            <div className="preview-card">
              <img src={image2} alt="Quiz Creation" className="preview-image" />
              <p>Easy Quiz Creation</p>
            </div>
          </div>
          <div className="preview-card" style={{ maxWidth: "600px", margin: "30px auto" }}>
            <img src={image3} alt="Student Results" className="preview-image" />
            <p>Comprehensive Results Analysis</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2 className="title-white">What Our Users Say</h2>
        <div className="carousel-container">
          <div className={`testimonial-carousel ${testimonials[currentTestimonial].featured ? 'featured' : ''}`}>
            <div className="testimonial-card">
              <div className="emoji-container">
                <span className="emoji">{testimonials[currentTestimonial].emoji}</span>
              </div>
              <div className="quote-container">
                {testimonials[currentTestimonial].quote.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="testimonial-quote">
                    {paragraph}
                  </p>
                ))}
              </div>
              <div className="testimonial-author">
                <h3 className="teacher-name">{testimonials[currentTestimonial].name}</h3>
                <p className="teacher-role">{testimonials[currentTestimonial].role}</p>
                {testimonials[currentTestimonial].school && (
                  <p className="teacher-school">{testimonials[currentTestimonial].school}</p>
                )}
              </div>
            </div>
          </div>
          
          <div className="carousel-controls">
            <button onClick={prevTestimonial} className="carousel-arrow">
              <span>⟵</span>
            </button>
            <span className="see-all">SEE ALL REVIEWS</span>
            <button onClick={nextTestimonial} className="carousel-arrow">
              <span>⟶</span>
            </button>
          </div>
        </div>

        {/* Statistics Display */}
        <div className="statistics-container">
          {statistics.map((stat, index) => (
            <div key={index} className="statistic-item">
              <div className="statistic-icon">{stat.icon}</div>
              <div className="statistic-value">{stat.value}%</div>
              <p className="statistic-description">{stat.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Student Feedback Section */}
      <section className="student-feedback-section">
        <h2 className="title-green">What Students Are Saying</h2>
        
        {/* General Student Testimonials */}
        <div className="testimonials-grid">
          <div className="student-testimonial-card">
            <div className="student-emoji">💬</div>
            <p className="student-quote">
              "I loved the aesthetics and the fact it's very organized. It makes reviewing answers super easy."
            </p>
            <div className="student-info">
              <p className="student-name">— Ayushi, Year 10</p>
            </div>
          </div>
          
          <div className="student-testimonial-card">
            <div className="student-emoji">💬</div>
            <p className="student-quote">
              "Good graphics, very good quality. The AI is very good at marking."
            </p>
            <div className="student-info">
              <p className="student-name">— Adam, Year 10</p>
            </div>
          </div>
          
          <div className="student-testimonial-card">
            <div className="student-emoji">💬</div>
            <p className="student-quote">
              "The easy-to-use layout and the colour scheme stood out to me the most."
            </p>
            <div className="student-info">
              <p className="student-name">— Aarin, Year 10</p>
            </div>
          </div>
          
          <div className="student-testimonial-card">
            <div className="student-emoji">💬</div>
            <p className="student-quote">
              "It's fast to get answers and the feedback helped me understand more."
            </p>
            <div className="student-info">
              <p className="student-name">— Ryan, Year 11</p>
            </div>
          </div>
          
          <div className="student-testimonial-card">
            <div className="student-emoji">💬</div>
            <p className="student-quote">
              "I like the fact that the AI can detect your answers no matter what format you put it in"
            </p>
            <div className="student-info">
              <p className="student-name">— Rehanna, Year 10</p>
            </div>
          </div>
          <div className="student-testimonial-card">
            <div className="student-emoji">💬</div>
            <p className="student-quote">
              "Best site i've used"
            </p>
            <div className="student-info">
              <p className="student-name">— Tony, Year 13</p>
            </div>
          </div>
        </div>
        
        {/* Senior Students Section */}
        <h3 className="senior-students-title">What Sixth Form students say</h3>
        <div className="senior-testimonials-grid">
          <div className="student-testimonial-card senior">
            <div className="student-emoji">🎓</div>
            <p className="student-quote">
              "The interface and View Quizzes feature are really useful. Feedback is instant, which makes revision easier."
            </p>
            <div className="student-info">
              <p className="student-name">— Benjamin, Year 13</p>
            </div>
          </div>
          
          <div className="student-testimonial-card senior">
            <div className="student-emoji">🎓</div>
            <p className="student-quote">
              "It automatically marks the answers with AI — super helpful for small tasks or practice."
            </p>
            <div className="student-info">
              <p className="student-name">— Ali, Year 12</p>
            </div>
          </div>
          
          <div className="student-testimonial-card senior">
            <div className="student-emoji">🎓</div>
            <p className="student-quote">
              "It's easy to use and navigate. I'd definitely use it for past papers or mock exams."
            </p>
            <div className="student-info">
              <p className="student-name">— Naji, Year 12</p>
            </div>
          </div>
        </div>
        
        {/* Feedback Data Section */}
        <div className="feedback-data-section">
          <div className="data-grid">
            <div className="data-item">
              <h4>Overall Experience Rating</h4>
              <div className="stat-card">
                <div className="stat-icon">⭐</div>
                <div className="stat-content">
                  <div className="stat-value">100<span>%</span></div>
                  <p className="stat-description">rated 4 or 5 stars</p>
                </div>
              </div>
            </div>
            
            <div className="data-item">
              <h4>Feedback Helpfulness</h4>
              <div className="stat-card">
                <div className="stat-icon">🧠</div>
                <div className="stat-content">
                  <div className="stat-value">100<span>%</span></div>
                  <p className="stat-description">said the feedback was helpful</p>
                </div>
              </div>
            </div>
            
            <div className="data-item">
              <h4>Ease of Use</h4>
              <div className="stat-card">
                <div className="stat-icon">✅</div>
                <div className="stat-content">
                  <div className="stat-value">80<span>%</span></div>
                  <p className="stat-description">rated 4 or 5 on usability</p>
                </div>
              </div>
            </div>
            
            <div className="data-item">
              <h4>Use for Revision</h4>
              <div className="stat-card">
                <div className="stat-icon">📚</div>
                <div className="stat-content">
                  <div className="stat-value">80<span>%</span></div>
                  <p className="stat-description">believe it can help with exam prep</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Summary Paragraph */}
        <div className="feedback-summary">
          <h3>Built with Students in Mind</h3>
          <p>
            From fast feedback to a clean, easy-to-use design — students loved the experience. 
            AI AutoMarker isn't just for teachers — it's helping learners get faster, clearer insights into their progress.
          </p>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <h2 className="title-green">How It Works</h2>
        <div className="timeline-container">
          <div className="timeline-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Create Question</h3>
              <p>Design your assessment with clear marking criteria</p>
            </div>
          </div>
          <div className="timeline-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Create Quiz</h3>
              <p>Set up the quiz with your custom requirements</p>
            </div>
          </div>
          <div className="timeline-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Share Code</h3>
              <p>Provide quiz code to your students</p>
            </div>
          </div>
          <div className="timeline-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Students Submit</h3>
              <p>Students complete and submit their answers</p>
            </div>
          </div>
          <div className="timeline-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <h3>AI Feedback</h3>
              <p>Get detailed feedback and results instantly</p>
            </div>
          </div>
        </div>
      </section>

      {/* Teachers Love Section */}
      <section className="teachers-love-section">
        <h2 className="title-green">Why Teachers Love It</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <h3>Save Time</h3>
            <p>Saves time without sacrificing feedback quality</p>
          </div>
          <div className="benefit-card">
            <h3>Stay in Control</h3>
            <p>Easy to review and moderate AI decisions</p>
          </div>
          <div className="benefit-card">
            <h3>Cross-Subject</h3>
            <p>Works across subjects (English, Computing, etc.)</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact-section">
        <h2 className="title-green">Want to use AI AutoMarker at your school?</h2>
        
        <div className="contact-form">
          <p className="contact-email">
            To request a demo or learn more, please email us at <a href="mailto:contact@aiautomarker.com">contact@aiautomarker.com</a>.
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <h2 className="title-green">Pricing</h2>
        <p className="time-saving-message">What if marking took seconds, not hours? Mark an entire class in 90 seconds — save 16 hours a month.</p>
        
        {/* Savings Calculator */}
        <div className="calculator-container">
          <h3 className="calculator-title">Calculate Your Savings</h3>
          
          <div className="calculator-inputs">
            <div className="input-group">
              <label>How many hours per week do you spend marking?</label>
              <input 
                type="number" 
                value={hoursPerWeek}
                onChange={(e) => setHoursPerWeek(Math.max(0, parseInt(e.target.value) || 0))}
                min="0"
              />
            </div>
            
            <div className="input-group">
              <label>How much is your time worth per hour (£)?</label>
              <input 
                type="number" 
                value={hourlyRate}
                onChange={(e) => setHourlyRate(Math.max(0, parseInt(e.target.value) || 0))}
                min="0"
              />
            </div>
          </div>
          
          <div className="calculator-results">
            <p>You could save {hoursPerWeek * 4} hours and £{hoursPerWeek * 4 * hourlyRate} per month by using AiAutoMarker — all for just £10/month.</p>
            {hoursPerWeek * 4 * hourlyRate - 10 > 0 && 
              <p>That's a net gain of £{hoursPerWeek * 4 * hourlyRate - 10} every month.</p>
            }
          </div>
          
        </div>
        
        <div className="teacher-pricing-container">
          <div className="teacher-pricing-card">
            <div className="pricing-tag">
              <span>💸 Let AI handle the grind — reclaim your weekends.</span>
            </div>
            
            <h3 className="teacher-pricing-title">AI AutoMarker for Teachers</h3>
            
            <div className="teacher-pricing-features">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <p>Start marking quizzes in seconds</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⏱️</div>
                <p>Save up to 4 hours per class</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">👨‍👩‍👧‍👦</div>
                <p>Invite your own students to join</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔄</div>
                <p>Token allowance: 500 responses/month</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🧮</div>
                <p>Equivalent to marking up to 25 classes per month</p>
              </div>
            </div>
            
            <div className="pricing-plans">
              <h4>Plans:</h4>
              <div className="plans-container">
                <div className="plan-option">
                  <h5>Free Trial</h5>
                  <p className="plan-price">7 days</p>
                </div>
                <div className="plan-option">
                  <h5>Monthly</h5>
                  <p className="plan-price">£9.99</p>
                </div>
                <div className="plan-option recommended">
                  <div className="recommended-badge">Popular</div>
                  <h5>6 Months</h5>
                  <p className="plan-price">£49.99</p>
                </div>
                <div className="plan-option">
                  <h5>Yearly</h5>
                  <p className="plan-price">£89.99</p>
                </div>
              </div>
            </div>
            
            <button className="start-trial-button" onClick={() => {
              document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
            }}>
              <span className="button-text">Contact Us</span>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <div className="footer-left">
            <p>© 2025 AI AutoMarker. All rights reserved.</p>
            <p>contact@aiautomarker.com</p>
          </div>
          <div className="footer-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms</a>
            <a href="/github">GitHub</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
